import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import { isMobileDevice, setCurrencyFormat } from 'src/utils/util';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const SummaryContainer = ({ nonTissueSummary, tissueSummary }) => {
    const { t } = useTranslation();
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const avenirRegularFont = 'AvenirNextWorld Regular';
    const SummaryContent = ({ title, qty, orgAmount, distAmcount, total }) => (
        <Grid
            container
            className={classes.contentPadding}
            justifyContent={'space-between'}
        >
            <Grid
                className={
                    total ? classes.summaryTotal : classes.summaryContent
                }
                item
                sm={4}
                xs={4}
            >
                <CustomLabel
                    styles={{
                        textAlign: 'left',

                        fontFamily: total
                            ? 'AvenirNextWorld Demi'
                            : avenirRegularFont,
                    }}
                    label={title}
                />
            </Grid>
            <Grid
                container
                className={
                    total ? classes.summaryTotal : classes.summaryContent
                }
                sm={4}
                xs={8}
            >
                <Grid item xs={6}>
                    <CustomLabel
                        styles={{
                            textAlign: 'center',
                            paddingRight: !isMobileDevice() && 20,

                            fontFamily: total
                                ? 'AvenirNextWorld Demi'
                                : avenirRegularFont,
                        }}
                        label={qty}
                    />
                </Grid>
                <Grid
                    className={
                        total ? classes.summaryTotal : classes.amountContent
                    }
                    item
                    xs={6}
                >
                    {distAmcount ? (
                        <StyledTextDiv
                            color={'#E5047E'}
                            //color={total ? '#140F4B' : '#202124'}
                            fontSize={'14px'}
                            textAlign={'end'}
                            textDecoration={'line-through'}
                            fontFamily={'AvenirNextWorld Regular'}
                        >
                            {formatCurrency(orgAmount)}
                        </StyledTextDiv>
                    ) : (
                        <StyledTextDiv
                            //color={total ? '#E5047E' : '#202124'}
                            color={'#140F4B'}
                            fontSize={'14px'}
                            textAlign={'end'}
                            //textDecoration={'line-through'}
                            fontFamily={
                                total
                                    ? 'AvenirNextWorld Demi'
                                    : 'AvenirNextWorld Regular'
                            }
                        >
                            {formatCurrency(orgAmount)}
                        </StyledTextDiv>
                    )}
                    {distAmcount && (
                        <StyledTextDiv
                            color={total ? '#140F4B' : '#202124'}
                            //color={'#E5047E'}
                            fontSize={'14px'}
                            textAlign={'end'}
                            fontFamily={
                                total
                                    ? 'AvenirNextWorld Demi'
                                    : 'AvenirNextWorld Regular'
                            }
                        >
                            {formatCurrency(distAmcount)}
                        </StyledTextDiv>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
    const formatCurrency = (amt) => {
        if (!amt) amt = 0;
        // return new Intl.NumberFormat(undefined, {
        //     style: 'currency',
        //     currency: 'USD',
        // }).format(amt);
        return setCurrencyFormat(amt);
    };
    const classes = useStyles();
    return (
        <React.Fragment>
            <Box
                className={classes.paper}
                my={1}
                bgcolor={'#ffffff'}
                boxShadow={2}
                borderRadius={6}
            >
                <Grid container justifyContent={'space-between'}>
                    <Grid className={classes.summaryHeader} item sm={4} xs={4}>
                        <text>{t('reportUsage.summary.title')}</text>
                    </Grid>
                    <Grid container sm={4} xs={8}>
                        <Grid className={classes.qtyHeader} item xs={6}></Grid>
                        <Grid className={classes.amountHeader} item xs={6}>
                            <text>{t('reportUsage.summary.amount')}</text>
                        </Grid>
                    </Grid>

                    {countryISOCode === 'US' ? (
                        <>
                            {' '}
                            <SummaryContent
                                title={t('reportUsage.summary.nonTissue')}
                                qty={nonTissueSummary.qty}
                                orgAmount={nonTissueSummary.orignalAmt}
                                // distAmcount= {nonTissueSummary.discountAmt}
                                distAmcount={
                                    nonTissueSummary.orignalAmt !==
                                    nonTissueSummary.discountAmt
                                        ? nonTissueSummary.discountAmt
                                        : null
                                }
                            />
                            <SummaryContent
                                title={t('reportUsage.summary.tissue')}
                                qty={tissueSummary.qty}
                                orgAmount={tissueSummary.orignalAmt}
                                distAmcount={
                                    tissueSummary.orignalAmt !==
                                    tissueSummary.discountAmt
                                        ? tissueSummary.discountAmt
                                        : null
                                }
                            />
                        </>
                    ) : (
                        <SummaryContent
                            title={t('common.itemsLabel')}
                            qty={nonTissueSummary.qty}
                            orgAmount={nonTissueSummary.orignalAmt}
                            distAmcount={
                                nonTissueSummary.orignalAmt !==
                                nonTissueSummary.discountAmt
                                    ? nonTissueSummary.discountAmt
                                    : null
                            }
                        />
                    )}
                    <SummaryContent
                        total
                        title={t('common.totalText')}
                        qty={
                            nonTissueSummary.qty + tissueSummary.qty
                            // accountOwnedSummary.qty
                        }
                        orgAmount={
                            nonTissueSummary.orignalAmt +
                            tissueSummary.orignalAmt
                            // accountOwnedSummary.orignalAmt
                        }
                        distAmcount={
                            nonTissueSummary.discountAmt +
                                tissueSummary.discountAmt !==
                            nonTissueSummary.orignalAmt +
                                tissueSummary.orignalAmt
                                ? nonTissueSummary.discountAmt +
                                  tissueSummary.discountAmt
                                : null
                        }
                    />
                </Grid>
            </Box>
        </React.Fragment>
    );
};

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    contentPadding: {
        paddingTop: '12px',
    },
    paper: {
        padding: theme.spacing(2),
    },
    summaryHeader: {
        textAlign: 'left',
        color: '#202124',
        fontSize: '13px',
        fontFamily: 'AvenirNextWorld demi',
        lineHeight: '20px',
    },
    qtyHeader: {
        textAlign: 'center',
        color: '#202124',
        fontSize: '13px',
        fontFamily: 'AvenirNextWorld demi',
        letterSpacing: '0.1px',
        lineHeight: '23px',
    },
    amountHeader: {
        textAlign: 'end',
        color: '#202124',
        fontSize: '13px',
        fontFamily: 'AvenirNextWorld demi',
        letterSpacing: '0.1px',
        lineHeight: '23px',
    },
    summaryContent: {
        textAlign: 'left',
        color: '#393939',
        fontSize: '14px',
        fontFamily: 'AvenirNextWorld reguler',
        letterSpacing: '0px',
        lineHeight: '24px',
    },
    summaryTotal: {
        color: '#140F4B',
        fontSize: '16px',
        fontFamily: 'AvenirNextWorld demi',
        letterSpacing: '-0.13px',
        lineHeight: '23px',
    },
    gridPadBottom: {
        paddingBottom: 8,
    },
}));

export default SummaryContainer;
